import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMobile, faEye, faEyeSlash, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Form, Button, FormControl, Spinner, InputGroup } from "react-bootstrap";
import Flag from "react-world-flags";
import { toast } from "react-toastify";
import API from "./api";
import img_entreprise from "../assets/Images/Logo_entreprise-removebg-preview.webp";
import "../../Styles/Login.css";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1); // 1: identifiant, 2: otp, 3: nouveau mdp
    const [modeEmail, setModeEmail] = useState(true);
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [resetToken, setResetToken] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const identifier = modeEmail ? email : phone.replace(/\s/g, "");

    const toggleMode = () => {
        setModeEmail(!modeEmail);
        setErrors({});
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, "").slice(0, 10);
        value = value.replace(/(\d{2})(?=\d)/g, "$1 ");
        setPhone(value);
    };


    // Étape 1: demande d'OTP
    const handleRequestOtp = async (e) => {
        e.preventDefault();
        setErrors({});

        if (!identifier.trim()) {
            setErrors({ identifier: modeEmail ? "Veuillez entrer un email" : "Veuillez entrer un numéro" });
            return;
        }

        setLoading(true);
        try {
            await API.post("/forgot-password/request-otp", { identifier });
            toast.success("Un code a été envoyé si ce compte existe.");
            setStep(2);
        } catch (err) {
            toast.error("Une erreur est survenue. Réessayez.");
        } finally {
            setLoading(false);
        }
    };

    // Étape 2: vérification OTP
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setErrors({});

        if (otp.length !== 4) {
            setErrors({ otp: "Le code doit contenir 4 chiffres" });
            return;
        }

        setLoading(true);
        try {
            const res = await API.post("/verify-reset-otp", { identifier, otp });
            setResetToken(res.data.reset_token);
            setStep(3);
        } catch (err) {
            setErrors({ otp: "Code invalide ou expiré" });
        } finally {
            setLoading(false);
        }
    };

    // Étape 3: nouveau mot de passe
    const handleResetPassword = async (e) => {
        e.preventDefault();
        setErrors({});

        const newErrors = {};
        if (password.length < 8) newErrors.password = "8 caractères minimum";
        if (password !== passwordConfirm) newErrors.passwordConfirm = "Les mots de passe ne correspondent pas";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);
        try {
            await API.post("/forgot-password/reset", {
                identifier,
                reset_token: resetToken,
                password,
                password_confirmation: passwordConfirm,
            });
            toast.success("Mot de passe réinitialisé avec succès");
            navigate("/login", { replace: true });
        } catch (err) {
            toast.error(err.response?.data?.message || "Session expirée, recommencez");
            setStep(1);

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="connexion_form">
            <div className="container-fluid">
                <div className="row">
                    <div className="offset-md-3 col-md-6 col-12">
                        <div className="formulaire_connexion my-5 p-3">

                            <ul
                                className="d-flex flex-row list-unstyled gap-2"
                                style={{ color: "#0066BD", cursor: "pointer" }}
                                onClick={() => (step === 1 ? navigate("/login") : setStep(step - 1))}
                            >
                                <li><FontAwesomeIcon icon={faArrowLeft} /></li>
                                <li>{step === 1 ? "Retour à la connexion" : "Retour"}</li>
                            </ul>

                            <div className="en-tête d-flex flex-column align-items-center">
                                <img src={img_entreprise} alt="Entreprise Logo" style={{ height: "50px" }} className="my-2" />
                                <h6 className="Subtitle_register m-2 text-center">
                                    {step === 1 && "Entrez votre email ou téléphone pour recevoir un code"}
                                    {step === 2 && "Entrez le code reçu"}
                                    {step === 3 && "Choisissez un nouveau mot de passe"}
                                </h6>
                            </div>

                            {/* ÉTAPE 1 */}
                            {step === 1 && (
                                <Form onSubmit={handleRequestOtp}>
                                    {modeEmail ? (
                                        <div className={`field-group ${errors?.identifier ? "has-error" : ""} ${email ? "has-value" : ""}`}>
                                            <span className="field-label">Email</span>
                                            <div className="input-group">
                                                <Form.Control
                                                    type="text"
                                                    className="input_register"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un numéro">
                                                    <FontAwesomeIcon icon={faMobile} />
                                                </Button>
                                            </div>
                                            {errors?.identifier && <div className="field-error">{errors.identifier}</div>}
                                        </div>
                                    ) : (
                                        <div className={`field-group has-prefix ${errors?.identifier ? "has-error" : ""} ${phone ? "has-value" : ""}`}>
                                            <span className="field-label">Numéro de téléphone</span>
                                            <div className="input-group">
                                                <InputGroup.Text className="phone-prefix">
                                                    <Flag code="BJ" style={{ width: "20px" }} />
                                                    +229
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="tel"
                                                    className="input_register"
                                                    value={phone}
                                                    onChange={handlePhoneChange}
                                                    style={{ borderLeft: "none" }}
                                                />
                                                <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un email">
                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                </Button>
                                            </div>
                                            {errors?.identifier && <div className="field-error">{errors.identifier}</div>}
                                        </div>
                                    )}

                                    <Button className="button_login w-100 mt-3" type="submit" disabled={isLoading}>
                                        {isLoading ? <Spinner size="sm" animation="border" /> : "Envoyer le code"}
                                    </Button>
                                </Form>
                            )}

                            {/* ÉTAPE 2 */}
                            {step === 2 && (
                                <Form onSubmit={handleVerifyOtp}>
                                    <div className={`field-group ${errors?.otp ? "has-error" : ""} ${otp ? "has-value" : ""}`}>
                                        <span className="field-label">Code à 6 chiffres</span>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={4}
                                            className="input_register text-center"
                                            style={{ letterSpacing: "0.5em", fontSize: "1.2rem" }}
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))}
                                        />
                                        {errors?.otp && <div className="field-error">{errors.otp}</div>}
                                    </div>

                                    <Button className="button_login w-100 mt-3" type="submit" disabled={isLoading}>
                                        {isLoading ? <Spinner size="sm" animation="border" /> : "Vérifier"}
                                    </Button>

                                    <p className="text-center mt-2">
                                        <span
                                            style={{ color: "#0066BD", cursor: "pointer", fontWeight: "bold" }}
                                            onClick={handleRequestOtp}
                                        >
                                            Renvoyer le code
                                        </span>
                                    </p>
                                </Form>
                            )}

                            {/* ÉTAPE 3 */}
                            {step === 3 && (
                                <Form onSubmit={handleResetPassword}>
                                    <div className={`field-group ${errors?.password ? "has-error" : ""} ${password ? "has-value" : ""}`}>
                                        <span className="field-label">Nouveau mot de passe</span>
                                        <div className="input-group">
                                            <FormControl
                                                type={showPassword ? "text" : "password"}
                                                className="input_register"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <Button variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                            </Button>
                                        </div>
                                        {errors?.password && <div className="field-error">{errors.password}</div>}
                                    </div>

                                    <div className={`field-group ${errors?.passwordConfirm ? "has-error" : ""} ${passwordConfirm ? "has-value" : ""}`}>
                                        <span className="field-label">Confirmer le mot de passe</span>
                                        <FormControl
                                            type={showPassword ? "text" : "password"}
                                            className="input_register"
                                            value={passwordConfirm}
                                            onChange={(e) => setPasswordConfirm(e.target.value)}
                                        />
                                        {errors?.passwordConfirm && <div className="field-error">{errors.passwordConfirm}</div>}
                                    </div>

                                    <Button className="button_login w-100 mt-3" type="submit" disabled={isLoading}>
                                        {isLoading ? <Spinner size="sm" animation="border" /> : "Réinitialiser"}
                                    </Button>
                                </Form>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;